import { Box, Typography } from "@mui/material";
import { isRouteErrorResponse, useRouteError } from "react-router";

function RootBoundary() {
  const error = useRouteError();
  console.log("error.status", error);

  const renderContent = () => {
    if (isRouteErrorResponse(error)) {
      if (error.status === 404) {
        return <div>This page doesn't exist!!</div>;
      }

      if (error.status === 401) {
        return <div>You aren't authorized to see this!</div>;
      }

      if (error.status === 503) {
        return <div>Looks like our API is down!</div>;
      }

      if (error.status === 418) {
        return <div>🫖</div>;
      }
    }

    return <div>Something went wrong!</div>;
  };

  return (
    <Box className="flex flex-col w-full h-full items-center justify-center">
      <Typography variant="h3">{error?.status ?? 500}</Typography>
      {renderContent()}
    </Box>
  );
}

export default RootBoundary;
